import { Modal } from "react-bootstrap";
import { useMerchant } from "../context/merchant";
import { useState } from "react";
import { toast } from "react-toastify";
import { openCloseAPI } from "../api/axios/requests";

export default function SettingsModal({ show, handleClose }) {
  const { isOpen, saveMerchantInfo } = useMerchant();

  const [loading, setLoading] = useState(false);
  const [userInteracted, setUserInteracted] = useState(true);

  const handleOpenOrganizationToggle = async (e) => {
    const newValue = e.target.checked;
    setLoading(true);

    try {
      const res = await openCloseAPI({ isOpen: newValue });
      if (res?.success) {
        saveMerchantInfo({ isOpen: newValue });
        toast.success("Амжилттай");
      } else {
        toast.error(res?.error || "Алдаа гарлаа.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Серверийн алдаа.");
    } finally {
      setLoading(false);
    }
  };

  const handleNotificationToggle = (e) => {
    setUserInteracted(e.target.checked);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-primary">
        <h4 className="header-title text-white">Тохиргоо</h4>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-centered mb-0">
          <tbody>
            <tr>
              <td style={{ borderBottom: "none" }}>
                Байгууллага {isOpen ? "хаах" : "нээх"}
              </td>
              <td style={{ borderBottom: "none" }}>
                <div className="d-flex justify-content-end">
                  {loading ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <>
                      <input
                        type="checkbox"
                        id="switch01"
                        checked={isOpen}
                        onChange={handleOpenOrganizationToggle}
                        data-switch="success"
                      />
                      <label
                        htmlFor="switch01"
                        data-on-label="Yes"
                        data-off-label="No"
                        className="mb-0 d-block"
                      />
                    </>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ borderBottom: "none" }}>
                Notification {userInteracted ? "унтраах" : "асаах"}
              </td>
              <td style={{ borderBottom: "none" }}>
                <div className="d-flex justify-content-end">
                  <input
                    type="checkbox"
                    id="switch02"
                    checked={userInteracted}
                    onChange={handleNotificationToggle}
                    data-switch="success"
                  />
                  <label
                    htmlFor="switch02"
                    data-on-label="Yes"
                    data-off-label="No"
                    className="mb-0 d-block"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn btn-outline-primary" onClick={handleClose}>
          Хаах
        </div>
      </Modal.Footer>
    </Modal>
  );
}
